import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./Loader.scss";
import { errorMessage } from "../../utils/errorMessage";
import { announce } from "./AccessibilityAnnouncer";
export interface ILoaderProps {
	color?: 'grey' | 'blue';
	size: 18 | 20 | 50 | 100;
	announce?: boolean;
	message?: string;
}

const Loader: React.FC<ILoaderProps> = ({ message }) => {
	const loaderMsg = message || errorMessage.loaderMsg;
	useEffect(() => {
		announce(loaderMsg);
	}, []);
	return (
		<div
			className="nv-loader"
			role="status"
			aria-live="polite"
			aria-busy="true"
		>
			<div className="nv-loader__visual" aria-hidden="true">
				<span className="nv-loader__ring" />
				<svg className="nv-loader__mark" viewBox="0 0 100 100">
					<g className="nv-loader__arc nv-loader__arc--up">
						<path d="M22 64a16 16 0 0 1 32 0" />
					</g>
					<g className="nv-loader__arc nv-loader__arc--down">
						<path d="M46 36a16 16 0 0 0 32 0" />
					</g>
				</svg>
			</div>
			<p className="nv-loader__text">
				{loaderMsg}
				<span className="nv-loader__dots" aria-hidden="true">
					<span />
					<span />
					<span />
				</span>
			</p>
		</div>
	);
};

export default Loader;
